import { Navigation, If, Loader } from '@itau-loans-www/components'

import AddressForm from '../AddressForm'
import BankDataForm from '../BankDataForm'
import PersonalDataForm from '../BasicDataForm'
import DocumentForm from '../DocumentForm'
import InputWrapper from '../InputWrapper'
import {
  useAddressFormControl,
  useBankDataFormControl,
  useDocumentFormControl,
  usePendingForm,
  usePersonalDataFormControl
} from './hooks'
import './pending-form.scss'

const PendingForm = ({
  nextButtonText = 'confirmar dados',
  initialValuesFromApi = {},
  handleSendProposal,
  IsFormCompleted,
  submitLoading
}) => {
  const { isLoading, handleGetNewOffer } = usePendingForm()

  const { banking_data, personal_data, document_data, address_data } =
    initialValuesFromApi

  const { bankDataFormControl, bankDataFormProps, isBankDataFormValid } =
    useBankDataFormControl(banking_data)

  const {
    personalDataFormProps,
    isPersonalDataFormValid,
    personalDataFormControl
  } = usePersonalDataFormControl(personal_data)

  const { documentFormControl, documentFormProps, isDocumentFormValid } =
    useDocumentFormControl(document_data)

  const {
    addressFormControl,
    addressFormProps,
    isAddressFormValid,
    addressFormSetValue
  } = useAddressFormControl(address_data)

  const isFormValid =
    isBankDataFormValid &&
    isPersonalDataFormValid &&
    isDocumentFormValid &&
    isAddressFormValid

  return (
    <form
      onSubmit={(event) =>
        handleSendProposal(event, {
          banking_data: bankDataFormProps.getValues(),
          document_data: documentFormProps.getValues(),
          personal_data: personalDataFormProps.getValues(),
          address_data: addressFormProps.getValues()
        })
      }
      className="pending-form"
    >
      <If condition={isLoading} renderIf={<Loader visible hasOverlay />} />

      <InputWrapper
        formOkText={'Seus dados bancários'}
        formOkCondition={isBankDataFormValid || IsFormCompleted}
        formShowCondition={banking_data?.has_issues}
      >
        <BankDataForm
          control={bankDataFormControl}
          formProps={bankDataFormProps}
          isValid={isBankDataFormValid}
          initialValues={banking_data}
        />
      </InputWrapper>

      <InputWrapper
        formOkText={'Dados pessoais'}
        formOkCondition={isPersonalDataFormValid || IsFormCompleted}
        formShowCondition={personal_data?.has_issues}
      >
        <PersonalDataForm
          control={personalDataFormControl}
          formProps={personalDataFormProps}
          isValid={isPersonalDataFormValid}
        />
      </InputWrapper>

      <InputWrapper
        formOkText={'Documentos'}
        formOkCondition={isDocumentFormValid || IsFormCompleted}
        formShowCondition={document_data?.has_issues}
      >
        <DocumentForm
          control={documentFormControl}
          formProps={documentFormProps}
          isValid={isDocumentFormValid}
          initialValues={document_data}
        />
      </InputWrapper>

      <InputWrapper
        formOkText={'Endereço'}
        formOkCondition={isAddressFormValid || IsFormCompleted}
        formShowCondition={address_data?.has_issues}
      >
        <AddressForm
          control={addressFormControl}
          setValue={addressFormSetValue}
          isValid={isAddressFormValid}
        />
      </InputWrapper>

      <Navigation
        submit
        nextButtonText={nextButtonText}
        isNextButtonDisabled={!isFormValid}
        isPrevButtonDisabled={submitLoading}
        isNextStepButtonLoading={submitLoading}
        onPrevStepClick={handleGetNewOffer}
        prevButtonText="Fazer nova simulação"
        prevButtonId={'pending-data-prev-btn'}
        nextButtonId={'pending-data-next-btn'}
      />
    </form>
  )
}

export default PendingForm
